import type { CurrencyCode } from '@percent/utility';

export const OPERATING_BUDGET_AMOUNT_KEY = 'operatingBudgetAmount';
export const OPERATING_BUDGET_CURRENCY_KEY = 'operatingBudgetCurrency';
export const DEFAULT_OPERATING_BUDGET_CURRENCY: CurrencyCode = 'USD';

// Mirrors backend Money column upper bound. 1,000,000,000.00 in any 2-decimal currency.
export const MAX_AMOUNT_MINOR_UNITS = 100_000_000_000;

export const getReservedKeySegment = (key: string): string => {
  const stripped = key.replace(/\[\]/g, '');
  const segments = stripped.split('.');
  return segments[segments.length - 1];
};
